import React, { Component } from "react";
// import { Link } from 'react-router-dom'
import {
  Button,
  Form,
  Input,
  Drawer,
  Divider,
  Dropdown,
  Popover,
  Row,
  Menu,
  Col,
  Select,
  Tag,
  Icon,
  Modal,
  message,
  Spin,
  List,
  Checkbox,
} from "antd";
import { api, app, config } from "../../app";
import QRCode from "../../components/QRCode";
import PayTemplate from "../../components/PayTemplate";
import head_default from "../../assets/head_default_img.png";
import xbImg from "../../assets/xb.png";
import xxImg from "../../assets/xx.png";

import cardImg from "../../assets/cardImg.png";
// import underscore from 'underscore'
import utils from "../../utils";

const FormItem = Form.Item;
const Search = Input.Search;
const Option = Select.Option;

/**
 * 生成胸标图片
 * @param vname
 * @param bsrno
 * @param pinyin
 * @returns {Promise<any>}
 */
function chestImg({ vname, bsrno, pinyin }) {
  return new Promise((resolve) => {
    let width = 400,
      height = 400,
      img = new Image(),
      canvas = document.createElement("canvas"),
      ctx = canvas.getContext("2d");
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      canvas.width = width;
      canvas.height = height;
      let ix = (width - img.width) / 2,
        iy = (height - img.height * 2) / 3,
        iy2 = iy * 2 + img.height;
      ctx.drawImage(img, ix, iy);
      ctx.drawImage(img, ix, iy2);
      ctx.fillStyle = "#FFFF00";
      ctx.textAlign = "center";
      //
      ctx.font = "bold 40px 黑体";
      vname = vname.split("").join(" ");
      ctx.fillText(vname, width / 2, iy + 56);

      //拼音
      ctx.fillText(pinyin, width / 2, iy + 100);

      //存心编号
      ctx.font = "bold 80px 黑体";
      ctx.fillText(bsrno, width / 2, iy2 + 90);

      let base64 = canvas.toDataURL("image/png");
      resolve(base64);
    };
    img.src = xbImg;
  });
}

/**
 * 生成工作证图片
 * @param data
 * @returns {Promise<string>}
 */
async function chestWorkImg(data) {
  // console.log("进来了2023");
  const canvas = document.getElementById("workCardImg");
  const ctx = canvas.getContext("2d");
  const bgImg = await utils.imageLoad(ctx, cardImg);
  ctx.drawImage(bgImg, 0, 0);
  if (data.volunteer_state === "3") return;
  ctx.font = "bold 11px 黑体";
  ctx.fillText(data.vname + "/" + data.pinyin, 117, 110); //
  ctx.fillText(data.teampositionname || "无", 117, 145); //职位
  ctx.fillText(data.teamname || "无", 117, 180); //所属分队
  ctx.fillText(data.bsrno || "无", 175, 197); //编号
  ctx.fillText(data.nickname || "无", 525, 86); //代号
  ctx.fillText(data.idno || "无", 531, 110); //身份识别ID
  ctx.fillText(data.passport || "无", 569, 132); //护照号
  ctx.fillText(data.bloodtype || "无", 550, 152); //血型

  ctx.fillText(data.drughis || "无", 466, 188); //药物过敏史

  // ctx.fillText(data.medicalhis || '无', 752, 146)     //重大医疗史

  ctx.fillText(data.emecontact || "无", 466, 213); //紧急联系人
  ctx.fillText(data.emecontactphone || "无", 466, 239); //紧急联系电话
  if (data.localpath) {
    const headImg = await utils.imageLoad(
      ctx,
      config.imgUrl + data.localpath,
      81,
      115
    );
    if (headImg) ctx.drawImage(headImg, 25, 84, 81, 114);
  } else {
    const headImg = await utils.imageLoad(ctx, head_default, 81, 115);
    if (headImg) ctx.drawImage(headImg, 25, 84, 81, 114);
  }
}

/**
 * 生成血型图片
 * @param vname
 * @param bloodtype
 * @returns {Promise<any>}
 */
function modifyImg({ vname, bloodtype_YL, bloodtype_FH, bloodtype_POS }) {
  return new Promise((resolve) => {
    let width = 400,
      height = 150,
      img = new Image(),
      canvas = document.createElement("canvas"),
      ctx = canvas.getContext("2d");
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      canvas.width = width;
      canvas.height = height;
      let ix = (width - img.width) / 2,
        iy = (height - img.height * 2) / 3,
        iy2 = iy * 2 + img.height;
      ctx.drawImage(img, ix, iy);
      ctx.drawImage(img, ix, iy2);

      ctx.fillStyle = "#FFFF00";
      ctx.textAlign = "center";

      //
      ctx.font = "bold 50px 黑体";
      vname = vname.split("").join(" ");
      ctx.fillText(vname, width / 2, iy + 190);

      //血型
      ctx.fillStyle = "#FF0000"; // 红色
      ctx.font = "bold 60px 黑体";
      if (bloodtype_YL == "AB") {
        ctx.fillText("AB", width / 2.25, iy + 260);
        //符号
        ctx.font = "bold 47px 黑体";
        ctx.fillText(bloodtype_FH, width / 1.75, iy + 245);
        // POS
        ctx.font = "bold 20px 黑体";
        ctx.fillText(bloodtype_POS, width / 1.75, iy + 260);
      } else {
        ctx.fillText(bloodtype_YL, width / 2.15, iy + 260);
        //符号
        ctx.font = "bold 47px 黑体";
        ctx.fillText(bloodtype_FH, width / 1.8, iy + 245);
        // POS
        ctx.font = "bold 20px 黑体";
        ctx.fillText(bloodtype_POS, width / 1.8, iy + 260);
      }

      let base64 = canvas.toDataURL("image/png");
      resolve(base64);
    };
    img.src = xxImg;
  });
}

const clear_receiver_data_name = React.createRef();
const clear_receiver_data_mobile = React.createRef();
// const clear_receiver_data_isTrue = React.createRef();
const clear_receiver_data_address = React.createRef();
const clear_current_province = React.createRef();
const clear_current_city = React.createRef();
const clear_current_area = React.createRef();

class MWorkCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      good_info: {},
      isImgModal: false,
      bloodtypeList: [],
      mall_id: props.match.params.id,
      sel_spec: [],
      firstload: false,
      bigImgVisible: false,
      bigImgInfo: {
        x: 0,
        y: 0,
      },
      pycorr: "",
      sel_prop_code: null,
      sel_custom_types: "",
      currentProductImg: "", // 当前选中的商品图片
      currentIndex: 0, // 当前选中的商品图片的下标，默认第一个
      product_img33: [1, 2, 3, 4, 5, 6],
      noxxData: [
        "https://img0.baidu.com/it/u=1559583370,1583672135&fm=253&fmt=auto&app=120&f=JPEG?w=658&h=411",
        "https://img2.baidu.com/it/u=3795729958,818568570&fm=253&fmt=auto&app=138&f=JPEG?w=293&h=500",
        "https://img1.baidu.com/it/u=1335955050,3868593504&fm=253&fmt=auto&app=120&f=JPEG?w=1200&h=502",
        "https://img0.baidu.com/it/u=3650258766,355660799&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=281",
        "https://img2.baidu.com/it/u=420156118,3874648934&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800",
        "https://img2.baidu.com/it/u=4047093194,3828699190&fm=253&fmt=auto&app=120&f=JPEG?w=1422&h=800",
        "https://img1.baidu.com/it/u=1667702599,1830065091&fm=253&fmt=auto&app=120&f=JPEG?w=800&h=800",
        "https://img1.baidu.com/it/u=418065478,17440416&fm=253&fmt=auto&app=138&f=PNG?w=323&h=500",
        "https://img2.baidu.com/it/u=1039592647,1119135417&fm=253&fmt=auto&app=120&f=JPEG?w=800&h=1280",
        "https://img2.baidu.com/it/u=240317671,2163976283&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500",
        "https://img1.baidu.com/it/u=2705347681,966875715&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500",
        "https://img1.baidu.com/it/u=578673941,2696974512&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=500",
        "https://img1.baidu.com/it/u=1542788652,3791174894&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=889",
        "https://img2.baidu.com/it/u=3612202329,1815592184&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=889",
        "https://img1.baidu.com/it/u=3460041514,16477474&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=313",
        "https://img0.baidu.com/it/u=2493879675,3382767603&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800",
        "https://img1.baidu.com/it/u=1880761403,1025846564&fm=253&fmt=auto&app=120&f=JPEG?w=658&h=370",
        "https://img2.baidu.com/it/u=3094549040,103926805&fm=253&fmt=auto&app=138&f=JPEG?w=333&h=500",
        "https://img2.baidu.com/it/u=1434490292,925007788&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=735",
        "https://img2.baidu.com/it/u=3099306206,1513634022&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=889",
        "https://img1.baidu.com/it/u=4130381281,2657262449&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800",
        "https://img2.baidu.com/it/u=3179278810,1582590113&fm=253&fmt=auto&app=138&f=JPEG?w=400&h=800",
        "https://img1.baidu.com/it/u=3097007933,3775451098&fm=253&fmt=auto&app=120&f=JPEG?w=1200&h=750",
        "https://img2.baidu.com/it/u=2176678119,512853671&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=889",
        "https://img1.baidu.com/it/u=794083458,890007594&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800",
        "https://img1.baidu.com/it/u=2045922693,212563729&fm=253&fmt=auto&app=120&f=JPEG?w=1024&h=576",
        "https://img1.baidu.com/it/u=1731998434,4033947124&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=800",
        "https://img0.baidu.com/it/u=2834175805,783453598&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800",
        "https://img2.baidu.com/it/u=1843278701,1380999079&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800",
        "https://img1.baidu.com/it/u=2867988205,1801778380&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=889",
        "undefined",
      ],
      xxddnnccx: [
        {
          name: "颜色",
          value_id: "001",
          list: ["白色", "黑色", "红色"],
        },
        {
          name: "尺码",
          value_id: "002",
          list: ["S", "M", "X", "XL", "XXL", "XXXL", "XXXXL"],
        },
        {
          name: "增值保障",
          value_id: "003",
          list: ["三月意外换新 ￥7.00", "意外破洞保 ￥9.00"],
        },
      ],
      spec_list: [],
      spec_list2: [],
      showCodeBox: false, // 是否展示小程序码
      moveStatus: false, // 是否可以点击箭头进行图片切换
      moveWidth: "", // 是否可以点击箭头进行图片切换的距离样式
      specStatus: false, // 是否显示库存
      specStock: "", // 库存数量
      specSprice: "0.00", // 选中规格的价格
      spec_arr: [], // 选中的规格属性数组
      showAddressBox: false, // 是否显示地址modal
      receivingInfor: {},
      eAdressStatus: false, // 是否显示编辑（新增）收货地址弹框
      regions_all: "", // 省份值
      regions_province: "", // 省份值
      regions_city: "", // 城市值
      regions_area: "", // 地区值
      current_province: "", // 当前选中的省份
      current_city: "", // 当前选中的城市
      current_area: "", // 当前选中的区域
      receiver_data: "", // 选中的收货地址数据
      join_loading: false, // 购物车加入loading
      xionbiao: "", // 单独获取胸标图片
      xuexing: "", // 单独获取血型图片
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.dataSource();
    await this.bloodtypeSource();
    await this.getDiqu();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * 设置值
   * @param obj
   */
  setData = (obj) => app.setStateSync(this, obj);

  /**
   * 数据
   */
  dataSource = async () => {
    let { mall_id } = this.state,
      params = {
        mall_id,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      };
    let { flag, data, msg } = await app.post(api.MallDetails, params);
    // console.log("data000");
    // console.log(data.user.localpath);

    // console.log(data);
    if (flag === 1) {
      let sel_spec = new Array(data.mall.pro.spec_list.length);
      // data.mall.localpath = config.imgUrl + data.mall.localpath

      if (mall_id === "4") {
        if (data.user != null) {
          data.mall.product_img[0] = await chestImg(data.user);
        }
      }

      if (mall_id === "687") {
        if (data.user != null) {
          data.mall.product_img[0] = await modifyImg(data.user);
        }
      }

      let a = "";
      if (data.mall.id == 4) {
      } else {
        if (data.mall.type == 1) {
          a = config.imgUrl + data.mall.product_img[0] || "";
        } else {
          if (data.mall.merchant_id == 2) {
            a = config.imgUrlType2 + data.mall.product_img[0] || "";
          } else {
            a = config.imgUrlType3 + data.mall.product_img[0] || "";
          }
        }
      }

      let b = [];
      if (data.mall.pro.spec_list) {
        data.mall.pro.spec_list.forEach((e) => {
          e.list.forEach((e2) => {
            e2.isshow = false;
          });
          b.push(e);
        });
      }
      // console.log("规格数组");
      // console.log(b);
      let c = false;
      if (data.mall.product_img.length > 6) {
        c = true;
      } else {
        c = false;
      }
      let d = {};
      // 设置默认收货地址
      if (data.address_list != "") {
        let a1, a2, a3, a4, a5, a6;
        (a1 = data.address_list[0].name || ""),
          (a2 = data.address_list[0].mobile || ""),
          (a3 = data.address_list[0].province || ""),
          (a4 = data.address_list[0].city || ""),
          (a5 = data.address_list[0].region || ""),
          (a6 = data.address_list[0].address || ""),
          (d = {
            vname: a1,
            mobile: a2,
            malladdr: a3 + a4 + a5 + a6,
          });
      }
      let f = "";
      if (data.mall.product_img.length > 0) {
        if (mall_id === "3") {
          f = data.user.localpath
            ? config.imgUrl + data.user.localpath
            : head_default;
        } else {
          f = data.mall.product_img[0];
        }
      }

      let g = "";
      if (data.mall.product_img.length > 0) {
        if (mall_id === "3") {
          g = data.user.localpath
            ? config.imgUrl + data.user.localpath
            : head_default;
        } else {
          g = data.mall.product_img[0];
        }
      }

      let isImgModal = false;

      // 如果有视频则把视频封面添加到product_img里面
      if (data.mall.video_url !== "") {
        // console.log(good_info);
        // if (data.mall != undefined && data.mall.product_img != undefined) {
        // console.log(data.mall.product_img);
        // let a = [];
        // a.push(data.mall.video_cover);
        data.mall.product_img.unshift(data.mall.video_cover);
        // console.log(data.mall.product_img);
        isImgModal = true;
        // }
      }

      await this.setData({
        isImgModal,
        good_info: data,
        sel_spec,
        pycorr: data.user.pinyin == null ? "" : data.user.pinyin_jc,
        currentProductImg: a,
        spec_list: b,
        currentIndex: 0,
        moveStatus: c,
        receivingInfor: d,
        xionbiao: f,
        xuexing: g,
      });

      if (mall_id === "3") {
        let daoa = data.user;
        // daoa.localpath = data.mall.product_img != '' || data.mall.product_img != undefined ? data.mall.product_img[0] : '';
        // console.log('daoa.localpath');
        // console.log(daoa.localpath);
        await chestWorkImg(data.user == null ? "" : daoa);
      }

      // 判断规格属性是否只有一个，是则自动选中该规格，反之不用
      let avNum = 0;
      if (data.mall.pro.spec_list.length == 1) {
        data.mall.pro.spec_list.forEach((av, avi) => {
          av.list.forEach((avb, avbi) => {
            if (avbi == 0) {
            }
            avNum++;
          });
        });
      }
      // console.log(avNum);
      if (avNum == 1) {
        this.handlePropertyClick2("", "", 0, 0);
      }
    } else {
      app.alert(msg, "warn");
    }
  };

  handlePay = async (e) => {
    // console.log('handlePay');
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        if (this.state.pay_loading) return false;
        // const { sel_spec } = this.state, ss = underscore.every(sel_spec, (item) => item)
        let ss = false;
        // console.log('！');
        let ress = this.setSpecList(this.state.spec_arr);
        if (ress == "") {
          ss = false;
        } else {
          ss = true;
        }
        if (!ss) {
          app.alert("请选择商品属性~", "warn");
          document.getElementsByClassName("work-card")[0].scrollTo(0, 0);
          return false;
        }
        app.alert("正在加载...", "loading", "50%", 0);
        await this.setData({ pay_loading: true });
        const { mall_id } = this.state,
          params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            name: values.name,
            mobile: values.mobile,
            address: values.address,
            message: values.message,
            is_cart: 0,
          };
        const info = [
          {
            mall_id,
            number: values.number || 1,
            money: values.money,
            // property: ress.join(',')
            sku_id: ress,
          },
        ];
        // console.log(info);
        params.info = JSON.stringify(info);
        const { flag, data, msg } = await app.post(api.MallPay, params);
        app.alertDestroy();
        if (flag === 1) {
          // window.open(data);
          app.alert("正在跳转支付...", "loading", "50%", 0);
          await app.sleep(1500);
          message.destroy();
          window.location.href = data;
          app.alertDestroy();
          // _this.props.history.push('/orders');
        } else {
          app.alert(msg, "warn");
        }
        this.setData({ pay_loading: false });
      }
    });
  };

  // 处理已选中的规格
  setSpecList = () => {
    let a = this.state.spec_arr;
    let b = [];
    let c = this.state.good_info.mall.pro.spec_info; //
    let d = "";
    if (a != "") {
      a.forEach((e) => {
        if (e.isshow) {
          b.push(e.name);
        }
      });
    }

    c.forEach((e) => {
      // console.log({
      //     '左': e.spec_value.sort().toString(),
      //     '右': b.sort().toString(),
      // })
      // console.log(e.spec_value.sort().toString());
      if (e.spec_value.sort().toString() == b.sort().toString()) {
        d = e.sku_id;
      }
    });

    return d;
  };

  /**
   * 购买支付
   * @param e
   */
  handlePay2 = (e) => {
    // console.log('handlePay2');
    e.preventDefault();

    if (this.state.spec_arr.length == 0) {
      message.warning("请选择规格属性");
    } else {
      this.props.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.state.pay_loading) return false;
          // const { sel_spec } = this.state;
          // ss = underscore.every(sel_spec, (item) => item)
          let ss = false;
          let ress = this.setSpecList(this.state.spec_arr);
          if (ress == "") {
            ss = false;
          } else {
            ss = true;
          }
          if (!ss) {
            app.alert("请选择商品属性~", "warn");
            document.getElementsByClassName("work-card")[0].scrollTo(0, 0);
            return false;
          }
          app.alert("正在加载...", "loading", "50%", 0);
          await this.setData({ pay_loading: true });
          let sss = values.number || 1;
          let number = parseFloat(this.state.specSprice).toFixed(2) || 1;
          // console.log(this.state.specSprice);
          // console.log(values.number);
          // console.log(number);
          debugger;
          const {
              mall_id,
              sel_custom_types,
              sel_prop_code,
              receivingInfor,
            } = this.state,
            params = {
              indexno: app.getData("indexno"),
              account: app.getData("account"),
              name: receivingInfor.vname,
              mobile: receivingInfor.mobile,
              address: receivingInfor.malladdr,
              message: values.message,
              is_cart: 0,
              // custom_types: sel_custom_types,
              // code_no: sel_prop_code ? sel_prop_code.code_no : '',
            };
          const info = [
            {
              mall_id,
              number: values.number || 1,
              money: number,
              sku_id: ress,
            },
          ];
          params.info = JSON.stringify(info);
          const { flag, data, msg } = await app.post(api.MallPay, params);
          // console.log('data');
          // console.log(data);
          app.alertDestroy();
          if (flag === 1) {
            Modal.confirm({
              title: "扫码支付",
              centered: true,
              icon: <Icon type="alipay-circle" style={{ color: "#00A1E9" }} />,
              width: 600,
              content: (
                <PayTemplate
                  qrcode={data.qrUrl}
                  money={data.totalAmount.toFixed(2)}
                  no={data.orderCode}
                />
              ),
              okText: "已支付",
              cancelText: "关闭",
              onOk: async () => {
                const { flag, msg } = await app.post(api.MConfirmPay, {
                  indexno: app.getData("indexno"),
                  account: app.getData("account"),
                  order_code: data.ordersNo,
                });
                if (flag === 1) {
                  app.alert("支付成功", "success");
                  this.props.history.push("/mall/orders");
                  return true;
                } else {
                  app.alert(msg, "warn");
                  throw false;
                }
              },
            });
          } else {
            app.alert(msg, "warn");
          }
          await this.setData({ pay_loading: false });
        }
      });
    }
  };

  // 打开小程序码
  handleCode = () => {
    let a = app.checkLogin();
    let isTrue = true;
    if (this.state.good_info.mall == undefined) {
      // 未登录,提示不能支付购买
      if (a) {
        app.alert("请登录后操作~", "warn");
        isTrue = false;
      }
    }
    if (isTrue) {
      // 判断有没有收货地址
      // 有，打开扫码弹窗
      this.setData({
        showCodeBox: true,
      });
      // 没有，提示
    }
  };

  // 关闭小程序码
  handleCode2 = () => {
    this.setData({
      showCodeBox: false,
    });
  };

  // 加入购物车
  joinCart = () => {
    const { good_info, specStock } = this.state;
    if (this.state.spec_arr.length == 0) {
      message.warning("请选择规格属性");
    } else {
      this.props.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.state.join_loading) return false;
          let ss = false;
          // 已选中的规格id
          let ress = this.setSpecList(this.state.spec_arr);
          // console.log('spec_arr');
          // console.log(this.state.spec_arr);
          if (ress == "") {
            ss = false;
          } else {
            ss = true;
          }
          if (!ss) {
            app.alert("请选择商品属性~", "warn");
            document.getElementsByClassName("work-card")[0].scrollTo(0, 0);
            return false;
          }
          // app.alert('正在加载...', 'loading', '50%', 0)
          await this.setData({ join_loading: true });
          // let number = parseFloat(this.state.specSprice).toFixed(2) || 1;

          debugger;
          let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            product_id: good_info.mall.id,
            sku_id: ress,
            number:
              this.props.form.getFieldValue("number") == undefined
                ? 1
                : this.props.form.getFieldValue("number"),
          };
          // console.log('params');
          // console.log(params);
          const { flag, data, msg } = await app.post(api.CartJoin, params);
          // console.log('data');
          // console.log(data);
          app.alertDestroy();
          if (flag === 1) {
            app.alert(msg, "success");
          } else {
            app.alert(msg, "warn");
          }
          await this.setData({ join_loading: false });
        }
      });
    }
  };

  /**
   * 属性选择队伍/省
   * @returns {Promise<any>}
   */
  handleSelPropTeam = (custom_types) => {
    return new Promise(async (resolve) => {
      app.alert("正在加载...", "loading", "45%", 0);
      let teamList = [],
        prop_code = null;
      const { flag, data, msg } = await app.post(api.MallUserProvinceTeam, {
        custom_types,
        ...app.getReqParams(),
      });
      if (flag === 1) {
        teamList = data;
      } else {
        app.alert(msg, "error");
      }
      app.alertDestroy();
      Modal.confirm({
        title: "购买对象",
        centered: true,
        content: (
          <Select
            style={{ width: "100%", marginTop: 10 }}
            placeholder="请选择"
            onChange={(v) => {
              if (v) {
                let vals = v.split(":::");
                prop_code = {
                  code_no: vals[0],
                  data_name: vals[1],
                };
              } else {
                prop_code = null;
              }
            }}
            showSearch
          >
            {teamList.map((t) => (
              <Option key={t.code_no} value={t.code_no + ":::" + t.data_name}>
                {t.data_name}
              </Option>
            ))}
          </Select>
        ),
        onOk: () => {
          resolve(prop_code);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });
  };

  /**
   * 商品属性点击
   **/
  handlePropertyClick = async (i, specpro) => {
    // console.log({ '下标': i, '内容': specpro });
    const sel_spec = [...this.state.sel_spec],
      state = {
        sel_prop_code: this.state.sel_prop_code,
        sel_custom_types: specpro.custom_types,
      };
    if (sel_spec[i] && sel_spec[i] === specpro.value_id) {
      sel_spec[i] = "";
      state.sel_prop_code = null;
    } else {
      if (String(specpro.is_popup) === "1") {
        const prop_code = await this.handleSelPropTeam(specpro.custom_types);
        if (prop_code) {
          sel_spec[i] = specpro.spec_id;
          state.sel_prop_code = prop_code;
        }
      } else {
        sel_spec[i] = specpro.spec_id;
        state.sel_prop_code = null;
      }
    }
    state.sel_spec = sel_spec;
    // console.log(sel_spec);
    await this.setData(state);
  };

  // 点击商品属性
  handlePropertyClick2 = (e, e2, i, i2) => {
    // console.log({
    //     '选中父级': e,
    //     '选中子级属性': e2,
    //     '父级下标': i,
    //     '子级下标': i2,
    // });
    let arr = this.state.spec_arr;
    if (this.state.spec_list != []) {
      let a = this.state.spec_list;
      // let b = [];
      a.forEach((ae, ai) => {
        if (i == ai) {
          ae.list.forEach((ae2, ai2) => {
            if (i2 == ai2) {
              ae2.isshow = true;
              // console.log(ae);
            } else {
              ae2.isshow = false;
            }
            arr.push(ae2);
          });
        }
      });

      arr.forEach((e, i) => {
        if (!e.isshow) {
          arr.splice(i, 1);
        }
      });

      // arr.push(ae2.name);
      // 去重
      let newArr = this.noRepeat(arr);
      this.setData({
        spec_list: a,
        spec_arr: newArr || [],
      });
      this.getStock(newArr);
      // 每次选择规格都要重置购买数量
      this.props.form.setFieldsValue({ number: 1 });
      // console.log(this.state.spec_arr);
    }
  };

  // 去重
  noRepeat = (arr) => {
    var newArr = arr.filter(function(value, index, self) {
      return self.indexOf(value) === index;
    });
    return newArr;
  };

  // 获取库存
  getStock = (e) => {
    let a = this.state.good_info.mall.pro.spec_info;
    let b = "";
    let c = [];
    let d = "0.00";
    let f = ""; // 图片
    e.forEach((i) => {
      if (i.isshow) {
        c.push(i.name);
      }
    });
    // console.log(c);
    a.forEach((i) => {
      // console.log({
      //     i: i.spec_value,
      //     c: c,
      // })
      if (i.spec_value.sort().toString() == c.sort().toString()) {
        b = i.stock || 0;
        d = i.price || "0.00";
        f = i.sku_img;
      }
    });
    // console.log("库存：" + d);
    let h = "";
    if (this.state.good_info.mall.type == 1) {
      h = config.imgUrl;
    } else {
      if (this.state.good_info.mall.merchant_id == 2) {
        h = config.imgUrlType2;
      } else {
        h = config.imgUrlType3;
      }
    }
    let g = f != "" ? h + f : h + this.state.good_info.mall.product_img[0];
    this.setData({
      specStatus: true,
      specStock: b,
      specSprice: d,
      currentProductImg: g,
    });
    // console.log(this.state.good_info.mall.type);
    if (this.state.type == 2) {
      document.getElementById("big_img").src = g;
    }
  };

  /**
   * 减数
   */
  handleMinusNum = () => {
    if (this.state.spec_arr == "") {
      message.warning("请先选择规格");
    } else {
      const number = parseInt(this.props.form.getFieldValue("number"));
      if (number <= 1) {
        app.alert("最少购买一件", "warn");
        return false;
      }
      this.props.form.setFieldsValue({ number: number - 1 });
    }
  };

  /**
   * 编辑数量
   */
  handleEditNum = (rule, value, callback) => {
    if (this.state.spec_arr == "") {
      message.warning("请先选择规格");
    } else {
      let reg = /^[1-9]\d*$/,
        number = parseInt(value),
        stock = parseInt(this.state.specStock || 0);
      if (!reg.test(value)) {
        number = 1;
      } else {
        if (number < 1) {
          app.alert("最少购买一件", "warn");
          number = 1;
        } else if (number > stock) {
          app.alert("库存不足", "warn");
          number = stock;
        }
      }
      this.props.form.setFieldsValue({ number });
      callback();
    }
  };

  /**
   * 加数
   */
  handleAddNum = () => {
    if (this.state.spec_arr == "") {
      message.warning("请先选择规格");
    } else {
      let number = parseInt(this.props.form.getFieldValue("number")) + 1,
        stock = parseInt(this.state.specStock || 0);
      if (number > stock) {
        app.alert("库存不足", "warn");
        number = stock;
      }
      this.props.form.setFieldsValue({ number });
    }
  };

  /**
   * 图片加载完毕
   **/
  handleImgLoad = () => {
    let { firstload } = this.state;
    if (!firstload) {
      const showImg = document.getElementById("showImg"),
        imgMask = document.getElementById("imgMask"),
        bigImg = document.getElementById("bigImg"),
        { src } = showImg.getElementsByTagName("img")[0];
      let b_img = new Image();
      b_img.src = src;
      b_img.id = "big_img";
      bigImg.appendChild(b_img);

      let big_img = document.getElementById("big_img");

      showImg.addEventListener(
        "mouseover",
        () => {
          // self.setData({bigImgVisible: true});
          // imgMask.style.top = e.offsetY + 'px';
          // imgMask.style.left = e.offsetX + 'px';
          imgMask.style.visibility = "visible";
          bigImg.style.visibility = "visible";
        },
        true
      );

      showImg.addEventListener(
        "mousemove",
        (e) => {
          let l = e.pageX - showImg.offsetLeft - imgMask.offsetWidth - 30;
          let t = e.pageY - showImg.offsetTop - imgMask.offsetHeight / 2;
          let tb = 0,
            lb = 0,
            rb = 480 - imgMask.offsetWidth,
            bb = 480 - imgMask.offsetHeight;

          if (t < tb) {
            t = 0;
          } else if (t > bb) {
            t = bb;
          }

          if (l < lb) {
            l = 0;
          } else if (l > rb) {
            l = rb;
          }
          let tempX = l / (showImg.offsetWidth - imgMask.offsetWidth);
          let tempY = t / (showImg.offsetHeight - imgMask.offsetHeight);

          big_img.style.left =
            -tempX * (big_img.offsetWidth - bigImg.offsetWidth) + "px";
          big_img.style.top =
            -tempY * (big_img.offsetHeight - bigImg.offsetHeight) + "px";
          imgMask.style.top = t + "px";
          imgMask.style.left = l + "px";
        },
        true
      );

      showImg.addEventListener(
        "mouseout",
        () => {
          imgMask.style.visibility = "hidden";
          bigImg.style.visibility = "hidden";
        },
        true
      );

      this.setData({ firstload: true });
    }
  };

  /**
   * 拼音纠错
   * @param pinyin
   * @returns {Promise<void>}
   */
  handlePYCorrection = async (pinyin, id) => {
    if (pinyin) {
      let params = {
        pinyin,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      };
      let { flag, msg } = await app.post(api.CorrectPinyin, params);
      if (flag === 1) {
        app.alert("修改成功~", "success");
        await this.dataSource();
        await this.getDiqu();
        this.setData({ pycorr_visible: false });
      } else {
        app.alert(msg, "warn");
      }
    } else {
      app.alert("请输入纠正后的拼音！", "warn");
    }
  };

  /**
   * 挂失
   * @returns {Promise<void>}
   */
  handleLoss = async () => {
    let loading = false;
    let reason = "";
    let change = (e) => {
      let { value } = e.target;
      reason = value;
    };
    Modal.confirm({
      title: "重做挂失",
      content: (
        <div>
          <Input
            style={{ margin: "20px 0" }}
            placeholder="请输入原因"
            onChange={change}
            maxLength={200}
          />
          <div style={{ color: "red" }}>
            {" "}
            注：工作证申请挂失后，管理员审核通过后方可重新购买。
          </div>
        </div>
      ),
      style: { top: "30%" },
      width: 500,
      keyboard: false,
      maskClosable: false,
      destroyOnClose: true,
      okText: "提交",
      cancelText: "取消",
      confirmLoading: loading,
      onOk: async () => {
        if (!reason) {
          app.alert("请输入原因！", "warn");
          return Promise.reject();
        }
        loading = true;
        let params = {
          reason,
          indexno: app.getData("indexno"),
          account: app.getData("account"),
        };
        let { flag, msg } = await app.post(api.LostEquip, params);
        if (flag === 1) {
          app.alert("挂失成功，等待审核~", "success");
        } else {
          app.alert(msg, "warn");
        }
        return Promise.resolve();
      },
    });
  };

  // 获得当前选中的图片
  getCurrentImg = (e, i) => {
    let a = "";
    if (this.state.good_info.mall.id == 4) {
      a = this.state.xionbiao || "";
    } else {
      if (this.state.good_info.mall.type == 1) {
        a = config.imgUrl + e || "";
      } else {
        if (this.state.good_info.mall.merchant_id == 2) {
          a = config.imgUrlType2 + e || "";
        } else {
          a = config.imgUrlType3 + e || "";
        }
      }
    }
    this.setData({
      currentProductImg: a,
      currentIndex: i,
      isImgModal: i == 0 ? true : false,
    });
    if (document.getElementById("big_img") == null) {
    } else {
      document.getElementById("big_img").src = a;
    }
  };

  // // 获得当前选中的图片
  // getCurrentImg2 = () => {
  //     let e = this.state.good_info.video_cover || '';

  //     let a = '';
  //     if (this.state.good_info.mall.id == 4) {
  //         a = this.state.xionbiao || '';
  //     } else {
  //         if (this.state.good_info.mall.type == 1) {
  //             a = config.imgUrl + e || '';
  //         } else {
  //             if (this.state.good_info.mall.merchant_id == 2) {
  //                 a = config.imgUrlType2 + e || '';
  //             } else {
  //                 a = config.imgUrlType3 + e || '';
  //             }
  //         }
  //     }
  //     this.setData({
  //         currentProductImg: a,
  //         isImgModal: false,
  //         currentIndex: '-1',
  //     });
  //     if (document.getElementById('big_img') == null) {

  //     } else {
  //         document.getElementById('big_img').src = a;
  //     }
  // }

  // 上一组图片
  prevArrow = () => {
    if (this.state.moveStatus && this.state.moveWidth != "-418px") {
      this.setData({
        moveWidth: "-418px",
      });
      let a = "";
      if (this.state.good_info.mall.type == 1) {
        a = config.imgUrl + this.state.good_info.mall.product_img[6] || "";
      } else {
        if (this.state.good_info.mall.merchant_id == 2) {
          a =
            config.imgUrlType2 + this.state.good_info.mall.product_img[6] || "";
        } else {
          a =
            config.imgUrlType3 + this.state.good_info.mall.product_img[6] || "";
        }
      }
      this.setData({
        currentProductImg: a,
        currentIndex: 6,
      });
      document.getElementById("big_img").src = a;
    }
  };

  // 下一组图片
  nextArrow = () => {
    if (this.state.moveStatus && this.state.moveWidth != "0") {
      this.setData({
        moveWidth: "0",
      });
      let a = "";
      if (this.state.good_info.mall.type == 1) {
        a = config.imgUrl + this.state.good_info.mall.product_img[0] || "";
      } else {
        if (this.state.good_info.mall.merchant_id == 2) {
          a =
            config.imgUrlType2 + this.state.good_info.mall.product_img[0] || "";
        } else {
          a =
            config.imgUrlType3 + this.state.good_info.mall.product_img[0] || "";
        }
      }
      this.setData({
        currentProductImg: a,
        currentIndex: 0,
      });
      document.getElementById("big_img").src = a;
    }
  };

  // 关闭收货信息
  closeTheAdress = () => {
    this.setData({
      showAddressBox: false,
    });
  };
  /**
   * 血型数据源
   */
  async bloodtypeSource() {
    const params = {
      account: app.getData("account"),
      indexno: app.getData("indexno"),
    };
    let { flag, data, msg } = await app.post(api.UBloodtypeSelectLists, params);
    const state = {};
    if (flag === 1) {
      state.bloodtypeList = data;
    } else {
      app.alert(msg, "error");
    }
    this.setData(state);
  }

  // 打开编辑（新增）收货地址弹框
  openEAddress = async (e, b) => {
    // 1: 打开切换地址（发往队部）
    // 2：打开新增地址（发往普通用户）
    // 3：打开切换地址（发往普通用户）
    // console.log(b);
    // 代表发往队部
    if (e == 1 || e == 3) {
      await this.setData({
        showAddressBox: true,
      });
      // 代表发往普通用户
    } else if (e == 2) {
      if (b == undefined) {
        await this.setData({
          receiver_data: "",
          current_province: "",
          current_city: "",
          current_area: "",
          eAdressStatus: true,
          showAddressBox: false,
        });
      } else {
        await this.setData({
          receiver_data: b || "",
          current_province: b.province || "",
          current_city: b.city || "",
          current_area: b.region || "",
          eAdressStatus: true,
          showAddressBox: false,
        });
      }

      // clear_receiver_data_name.current.setState({ value: b.name });
      // clear_receiver_data_mobile.current.setState({ value: b.mobile });
      // clear_receiver_data_isTrue.current.setState({ value: b.receiver_default });
      // clear_receiver_data_address.current.setState({ value: b.address });
      // clear_current_province.current.setState({ value: b.province });
      // clear_current_city.current.setState({ value: b.city });
      // clear_current_area.current.setState({ value: b.region });
    }
    // 加载地区接口
    // this.getDiqu();
    // console.log("赋值后");
    // console.log(this.state.receiver_data);
  };

  // 加载地区接口（省）
  getDiqu = async (e) => {
    let { flag, data, msg } = await app.post(api.SkillTrainRegions, {
      type: 3,
    });
    if (flag === 1) {
      let arr = [];

      if (data) {
        data.forEach((a, ai) => {
          arr.push(a.region_name);
        });
        this.setData({
          // current_city: '',
          // current_area: '',
          regions_all: data,
          regions_province: arr,
          regions_city: "",
          regions_area: "",
        });
      }
    } else {
      app.alert(msg, "warn");
    }
  };

  // 加载地区接口（市）
  getCity = (e) => {
    // console.log(e);
    const data = this.state.regions_all;

    if (data) {
      let arr = [];
      data.forEach((a, ai) => {
        if (e == a.region_name) {
          // console.log("我进来啊了")
          // console.log(a.sublevel);
          // console.log("=====");
          if (a.sublevel) {
            a.sublevel.forEach((b, bi) => {
              arr.push(b.region_name);
            });
          } else {
            // console.log("==> "+a.region_name);
            arr.push("");
          }
        }
      });
      this.setData({
        regions_city: arr,
        regions_area: "",
        current_province: e,
        current_area: "",
        current_city: "",
      });
      // console.log(arr);
    }
  };

  // 加载地区接口（区）
  getArea = (e) => {
    const data = this.state.regions_all;
    const current_city = this.state.current_province;
    // console.log(data);
    // console.log(e);
    // console.log(this.state.current_city);

    if (data) {
      let arr = [];
      data.forEach((a, ai) => {
        // console.log(a.sublevel);
        if (current_city == a.region_name) {
          // console.log(a.region_name);
          // console.log(a.sublevel);
          a.sublevel.forEach((b, bi) => {
            if (e == b.region_name) {
              b.sublevel.forEach((c, ci) => {
                arr.push(c.region_name);
              });
            }
          });
        }
      });
      this.setData({
        regions_area: arr,
        current_city: e,
        current_area: "",
      });
      // console.log(arr);
    }
  };

  // 选择地址
  selectAddress = (e) => {
    // console.log(e);
    let a = this.state.receivingInfor;
    let b = {
      malladdr: e.province + e.city + e.region + e.address,
      mobile: e.mobile,
      vname: e.name,
    };
    let c = { ...a, ...b };
    this.setData({
      receivingInfor: c,
      receiver_data: e || "",
    });
    // console.log(this.state.good_info.user)
    this.closeTheAdress();
  };

  // 设置地址
  setCurrentRegion = (a, b) => {
    // console.log(b);
    if (a == 1) {
      // 选择省份
      this.getCity(b);
    } else if (a == 2) {
      // 选择城市
      this.getArea(b);
    } else if (a == 3) {
      // 选择区域
      this.setState({
        current_area: b,
      });
    }
  };

  // 关闭编辑（新增地址）
  handleCodeEAdress = () => {
    this.setState({
      eAdressStatus: false,
      receiver_data: "",
      current_province: "",
      current_city: "",
      current_area: "",
    });
    // console.log(clear_receiver_data_isTrue);
    clear_receiver_data_name.current.setState({ value: "" });
    clear_receiver_data_mobile.current.setState({ value: "" });
    // clear_receiver_data_isTrue.current.setState({ value: "" });
    clear_receiver_data_address.current.setState({ value: "" });
    clear_current_province.current.setState({ value: "" });
    clear_current_city.current.setState({ value: "" });
    clear_current_area.current.setState({ value: "" });
    // console.log(this.state.receiver_data);
  };

  // 去购物车
  goToCart = () => {
    let a = app.checkLogin();
    if (a) {
      app.alert("请登录后操作");
      setTimeout(() => {
        this.props.history.push("/login");
      }, 500);
    } else {
      this.props.history.push("/cart_index/");
    }
  };

  // 血型纠错
  getcorrect = async () =>{
    let {selectedBloodType} = this.state;
    if(selectedBloodType){
      let params = {
        indexno: app.getData("indexno"),
        account: app.getData("account"),
        bloodtype: selectedBloodType,
      };
      const { flag, msg } = await app.post(api.correctXueXing, params);
        if (flag === 1) {
          app.alert("修改成功~", "success");
          await this.dataSource();
          await this.getDiqu();
          this.setData({ pycorr_visible: false });
        } else {
          app.alert(msg, "warn");
        }
    }else{
      app.alert("请选择纠正后的血型！", "warn");
    }
  }


  // 删除选中的地址
  delCurrentAddress = async (e) => {
    // console.log(e);
    let params = {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
      receiver_id: e.receiver_id || "",
    };
    const { flag, msg } = await app.post(api.delAddress, params);
    if (flag === 1) {
      message.success(msg);
      // 关闭收货信息弹窗
      this.closeTheAdress();
      this.dataSource();
    } else {
      message.error(msg);
    }
  };

  // getZhi = event => {
  //     event.preventDefault()
  //     console.log(666);
  // }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form,
      {
        good_info,
        pay_loading,
        join_loading,
        sel_spec,
        pycorr_visible,
        pycorr,
        sel_prop_code,
        receivingInfor,
        showCodeBox,
        eAdressStatus,
        showAddressBox,
        receiver_data,
        xionbiao,
        xuexing,
        bloodtypeList,
      } = this.state,
      mall = good_info.mall || {},
      user = good_info.user || {},
      user_head =
        xionbiao != ""
          ? app.urlEncode(xionbiao)
          : xuexing != ""
          ? app.urlEncode(xuexing)
          : head_default,
      number = parseInt(getFieldValue("number") || "1");

    const { address_list } = good_info || [];

    let pyCorrection = (
      <div style={{ width: 400 }}>
        <Search
          placeholder="纠正后的拼音"
          enterButton="确定"
          value={pycorr}
          onChange={(e) => this.setData({ pycorr: e.target.value })}
          onSearch={(value) => this.handlePYCorrection(value)}
        />
        <div style={{ color: "red", marginTop: 10 }}>
          注：拼音用于制作工作证和胸标，请正确填写。
        </div>
      </div>
    );

    let pyCorrection2 = (
      <div style={{ width: 400 }}>
        <Search
          placeholder="纠正后的拼音"
          enterButton="确定"
          value={pycorr}
          onChange={(e) => this.setData({ pycorr: e.target.value })}
          onSearch={(value) => this.handlePYCorrection(value)}
        />
        <div style={{ color: "red", marginTop: 10 }}>
          注：拼音用于制作工作证和胸标，请正确填写。
        </div>
      </div>
    );

    let pyCorrection3 = (
      <div style={{ width: 400 }}>
        <Select style={{ width: "60%" }} placeholder="请填写您的血型"  onChange={(value) => this.setState({ selectedBloodType: value })}>
          {bloodtypeList.map((b) => {
            return (
              <Option key={b.value} value={b.value}>
                {b.title}
              </Option>
            );
          })}
        </Select>
        <Button
          size="small"
          className="update-btn"
          style={{ marginLeft: 10 }}
          type="primary"
          onClick={() => {
            this.getcorrect();
          }}
        >
          确定
        </Button>
        <div style={{ color: "red", marginTop: 10 }}>
          注：血型用于制作血型标，请正确填写。
        </div>
      </div>
    );

    const AddNewAddress = () => {
      return (
        <div
          style={{
            width: "100%",
            textAlign: "center",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>收货信息</div>
          {mall.is_team == 1 ? null : (
            <div
              onClick={() => this.openEAddress(2, "")}
              style={{
                paddingRight: "20px",
                color: "#1890ff",
                cursor: "pointer",
              }}
            >
              新增收货信息
            </div>
          )}
        </div>
      );
    };

    const params = {
      name: this.state.receiver_data.name || "",
      num: this.state.receiver_data.mobile || "",
      address: this.state.receiver_data.address || "",
      isTrue:
        this.state.receiver_data.receiver_default == 1 ||
        this.state.receiver_data.receiver_default == true
          ? 1
          : 0,
    };

    // 获取输入收货人
    const getName = (e) => {
      // console.log(e.target.value)
      params.name = e.target.value;
      let a = this.state.receiver_data;
      let b = { ...a, name: e.target.value };
      this.setState({
        receiver_data: b,
      });
    };

    // 获取输入收货人手机号
    const getNum = (e) => {
      // console.log(e.target.value);
      params.num = e.target.value;
      let a = this.state.receiver_data;
      let b = { ...a, mobile: e.target.value };
      this.setState({
        receiver_data: b,
      });
    };

    // 获取输入详细收货地址
    const getMoreAddress = (e) => {
      // console.log(e.target.value)
      params.address = e.target.value;
      let a = this.state.receiver_data;
      let b = { ...a, address: e.target.value };
      this.setState({
        receiver_data: b,
      });
    };

    // 设置是否默认
    const changeCheckbox = () => {
      // console.log(e);
      // console.log(e.target.checked);

      let a = this.state.receiver_data;

      let b = { ...a, receiver_default: a.receiver_default == 1 ? 0 : 1 };
      this.setState({
        receiver_data: b,
      });
    };

    // 保存
    const save = async () => {
      // console.log(params);
      // console.log(this.state.current_province);
      // console.log(this.state.current_city);
      // console.log(this.state.current_area);
      let isTrue = true;
      // 检查收货人
      if (params.name == "") {
        message.warn("请填写收货人");
        isTrue = false;
      } else if (params.name.length > 25) {
        message.warn("收货人长度不能超过25位");
        isTrue = false;
      } else if (params.num.toString() === "") {
        message.warn("请填写手机号码");
        isTrue = false;
      } else if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(params.num)) {
        message.warn("请填写正确的手机号码");
        isTrue = false;
      } else if (this.state.current_province == "") {
        message.warn("请选择省份");
        isTrue = false;
      } else if (this.state.current_city == "") {
        message.warn("请选择城市");
        isTrue = false;
      } else if (this.state.current_area == "") {
        message.warn("请选择区域");
        isTrue = false;
      } else if (params.address == "") {
        message.warn("请填写详细地址");
        isTrue = false;
      }

      if (isTrue) {
        // console.log("调接口");

        let a = {
          indexno: app.getData("indexno"),
          account: app.getData("account"),
          receiver_name: params.name,
          province: this.state.current_province,
          city: this.state.current_city,
          district: this.state.current_area,
          receiver_address: params.address,
          receiver_mobile: params.num,
          receiver_default: params.isTrue ? 1 : 0,
        };
        let bpi = "";
        if (
          this.state.receiver_data.receiver_id != "" &&
          this.state.receiver_data.receiver_id != undefined
        ) {
          a.receiver_id = this.state.receiver_data.receiver_id;
          bpi = api.editAddress;
        } else {
          bpi = api.addAddress;
        }
        // console.log(this.state.receiver_data.receiver_id);

        let { flag, data, msg } = await app.post(bpi, a);
        if (flag === 1) {
          message.success(msg);
          this.handleCodeEAdress();
          this.dataSource();
        } else {
          app.alert(msg, "warn");
        }
      }
    };

    return (
      <div className="work-card" id="work-card">
        <Form>
          <div className="page-content">
            {mall.id === "3" ? (
              <div className="user-info">
                <div className="user-info2">
                  <p className="user-img">
                    <img src={user_head ? user_head : head_default} alt="" />
                    {/* <Button size="small" className='update-btn'>修改</Button> */}
                  </p>
                  <div className="user-left">
                    <p className="user-item">
                      <label></label>
                      <span>
                        {user.vname} / {user.pinyin}
                      </span>
                      <Popover
                        placement="rightTop"
                        title="拼音纠错"
                        visible={pycorr_visible}
                        content={pyCorrection}
                      >
                        <Button
                          size="small"
                          className="update-btn"
                          type="primary"
                          onClick={() => {
                            let pv = !pycorr_visible;
                            let obj = { pycorr_visible: pv };
                            if (!pv) {
                              obj.pycorr = user.pinyin;
                            }
                            this.setData(obj);
                          }}
                        >
                          拼音纠错
                        </Button>
                      </Popover>
                    </p>
                    <p className="user-item">
                      <label>职位</label>
                      <span>
                        {user.teampositionname || "-"}
                        <Button size="small" className="update-btn" hidden>
                          纠错
                        </Button>
                      </span>
                    </p>
                    <p className="user-item">
                      <label>所属队伍</label>
                      <span>
                        {user.teamname || "-"}
                        <Button size="small" className="update-btn" hidden>
                          纠错
                        </Button>
                      </span>
                    </p>
                    <p className="user-item">
                      <label>存心编号</label>
                      <span>{user.bsrno || "-"}</span>
                    </p>
                    <p className="user-item">
                      <label>代号</label>
                      <span>{user.nickname || "-"}</span>
                    </p>
                    <p className="user-item">
                      <label>身份证号码</label>
                      <span>{user.idno || "-"}</span>
                    </p>
                    <p className="user-item">
                      <label>护照</label>
                      <span>{user.passport || "-"}</span>
                    </p>
                    {mall.type == 2 ? (
                      <div>
                        <p className="user-item" style={{ marginBottom: 0 }}>
                          <label>配送方式</label>
                          <span>{mall.mail_way == 1 ? "包邮" : "不包邮"}</span>
                        </p>
                      </div>
                    ) : null}
                  </div>
                  <div className="user-right">
                    <p className="user-item">
                      <label>血型</label>
                      <span>{user.bloodtype || "-"}</span>
                    </p>
                    <p className="user-item">
                      <label>药物过敏史</label>
                      <span>{user.drughis || "-"}</span>
                    </p>
                    <p className="user-item">
                      <label>紧急联系人</label>
                      <span>{user.emecontact || "-"}</span>
                    </p>
                    <p className="user-item">
                      <label>紧急联系人电话</label>
                      <span>{user.emecontactphone || "-"}</span>
                    </p>
                    <p className="user-item">{mall.remark || ""}</p>

                    <p className="user-item" style={{ color: "red" }}>
                      {mall.statement || ""}
                    </p>
                    {mall.type == 2 ? (
                      <div>
                        <p className="user-item" style={{ marginBottom: 0 }}>
                          <label>店铺名称</label>
                          <span>
                            {mall.merchant_name == undefined ||
                            mall.merchant_name == ""
                              ? "-"
                              : mall.merchant_name}
                          </span>
                        </p>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div
                  style={{ height: "1px", background: "#fff", margin: "8px 0" }}
                ></div>

                <div
                  style={{
                    paddingLeft: "175px",
                    height: "22px",
                    display: "flex",
                  }}
                >
                  {(this.state.spec_list || []).map((p, i) => {
                    return (
                      <dl key={i} style={{ display: "flex" }}>
                        <dt>{p.name}:</dt>
                        <dd>
                          {(p.list || []).map((sp, i2) => {
                            return (
                              <Tag
                                key={i2}
                                color={sp.isshow ? "#1890ff" : "blue"}
                                style={{
                                  borderWidth: "2px",
                                  margin: "0 5px",
                                }}
                                onClick={() =>
                                  this.handlePropertyClick2(p.list, sp, i, i2)
                                }
                              >
                                {sp.name}
                              </Tag>
                            );
                          })}
                        </dd>
                      </dl>
                    );
                  })}
                  {this.state.spec_arr != "" ? (
                    <dl style={{ display: "flex", paddingLeft: "10px" }}>
                      <dt>已选:</dt>
                      <dd>
                        {this.state.spec_arr != "" ? (
                          <div
                            style={{
                              backgroundColor: "#f2f2f2",
                              borderRadius: "4px",
                              padding: "0px 10px",
                              display: "inline-block",
                              marginLeft: "5px",
                            }}
                          >
                            {(this.state.spec_arr || []).map((e, i) => {
                              return (
                                <span key={i}>
                                  {e.isshow ? " " + e.name + " " : ""}
                                </span>
                              );
                            })}
                          </div>
                        ) : null}
                        {Number(this.state.specStock) === 0 &&
                        this.state.spec_arr != "" &&
                        this.state.specStock !== "" ? (
                          <span style={{ color: "red", paddingLeft: "4px" }}>
                            该商品已售完
                          </span>
                        ) : null}
                      </dd>
                    </dl>
                  ) : null}
                </div>

                <div
                  style={{
                    height: "1px",
                    background: "#e8e8e8",
                    margin: "8px 0",
                  }}
                ></div>

                <div className="car-img">
                  <canvas id="workCardImg" width="969" height="268" />
                </div>

                <div style={{ color: "red", marginTop: 10, paddingLeft: 350 }}>
                  <p>
                    {/* 1、 */}
                    {/* 志愿者不能购买制式装备，故不显示工作证预览信息 */}
                    {mall.ppe_remark || ""}
                  </p>
                  {/* <p>
                                                2、尚未注册登记的队伍不予制作工作证，请与队长或管理员确认自己所属队伍是否已注册登记 并已上传到信息公开平台
                                            </p>
                                            <p>
                                                3、队员同时属于多个队伍的情况下，制作工作证时只展示已注册登记的所属队伍，请知悉
                                            </p> */}
                </div>
              </div>
            ) : (
              <Row
                className="good-info"
                type="flex"
                style={{
                  height:
                    mall.type == 2
                      ? "calc(100% - 104px)"
                      : "calc(100% - 200px)",
                }}
              >
                <Col className="gi-img">
                  {mall.video_url ? (
                    <div>
                      {!this.state.isImgModal ? (
                        <div
                          className="show-img"
                          id="showImg"
                          style={{ cursor: "pointer" }}
                        >
                          <div className="img-mask" id="imgMask" />
                          <img
                            className="small-img"
                            style={{ maxHeight: "476px" }}
                            src={
                              mall.id == 4
                                ? xionbiao
                                : mall.id == 687
                                ? xuexing
                                : this.state.currentProductImg
                            }
                            alt=""
                            onLoad={() => this.handleImgLoad()}
                          />
                          <div id="bigImg" className="bigImg"></div>
                        </div>
                      ) : (
                        <div className="show-img">
                          <video
                            src={config.imgUrl + mall.video_url}
                            poster={config.imgUrl + mall.video_cover}
                            style={{ width: "100%", verticalAlign: "middle" }}
                            controls={true}
                            controlsList="nodownload"
                          >
                            您的浏览器不支持视频播放。
                          </video>
                        </div>
                      )}
                      <div className="navBottom">
                        <div
                          className="navBottomArrow"
                          onClick={() => this.nextArrow()}
                        >
                          <div className="xoxoxo"></div>
                        </div>
                        <div className="navBottomBox">
                          <div
                            className="navBottomContent"
                            style={{
                              left: this.state.moveWidth || "0px",
                            }}
                          >
                            {/* {mall.product_img} */}
                            {(mall.product_img || []).map((e, i) => {
                              return (
                                <img
                                  className="navBottomContentImg"
                                  src={
                                    mall.id == 4
                                      ? xionbiao
                                      : mall.id == 687
                                      ? xuexing
                                      : mall.type == 1
                                      ? config.imgUrl + e
                                      : mall.merchant_id == 2
                                      ? config.imgUrlType2 + e
                                      : config.imgUrlType3 + e
                                  }
                                  key={i}
                                  alt=""
                                  style={{
                                    borderColor:
                                      this.state.currentIndex == i
                                        ? "#40a9ff"
                                        : "#fff",
                                  }}
                                  onMouseEnter={() => this.getCurrentImg(e, i)}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="navBottomArrow">
                          <div
                            className="xoxoxo xoxoxo2"
                            onClick={() => this.prevArrow()}
                          ></div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {/* <a href={mall.type == 1 ? config.imgUrl + xionbiao : (mall.merchant_id == 2 ? config.imgUrlType2 + xionbiao : config.imgUrlType3 + xionbiao)} target="_blank"> */}
                      <div
                        className="show-img"
                        id="showImg"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="img-mask" id="imgMask" />
                        <img
                          className="small-img"
                          style={{ maxHeight: "476px" }}
                          src={
                            mall.id == 4
                              ? xionbiao
                              : mall.id == 687
                              ? xuexing
                              : this.state.currentProductImg
                          }
                          alt=""
                          onLoad={() => this.handleImgLoad()}
                        />
                        <div id="bigImg" className="bigImg"></div>
                      </div>
                      {/* </a> */}
                      <div className="navBottom">
                        <div
                          className="navBottomArrow"
                          onClick={() => this.nextArrow()}
                        >
                          <div className="xoxoxo"></div>
                        </div>
                        <div className="navBottomBox">
                          <div
                            className="navBottomContent"
                            style={{
                              left: this.state.moveWidth || "0px",
                            }}
                          >
                            {(mall.product_img || []).map((e, i) => {
                              return (
                                <img
                                  className="navBottomContentImg"
                                  src={
                                    mall.id == 4
                                      ? xionbiao
                                      : mall.id == 687
                                      ? xuexing
                                      : mall.type == 1
                                      ? config.imgUrl + e
                                      : mall.merchant_id == 2
                                      ? config.imgUrlType2 + e
                                      : config.imgUrlType3 + e
                                  }
                                  key={i}
                                  alt=""
                                  style={{
                                    borderColor:
                                      this.state.currentIndex == i
                                        ? "#40a9ff"
                                        : "#fff",
                                  }}
                                  onMouseEnter={() => this.getCurrentImg(e, i)}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="navBottomArrow">
                          <div
                            className="xoxoxo xoxoxo2"
                            onClick={() => this.prevArrow()}
                          ></div>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
                <Col className="gi-news">
                  <p className="good-name">{mall.ppename}</p>

                  <dl>
                    <dt>价格:</dt>
                    <dd className="good-price">
                      <em>￥</em>
                      <span>
                        {Number(this.state.specSprice) > 0
                          ? this.state.specSprice
                          : mall.ppeprice}
                      </span>
                    </dd>
                  </dl>

                  {/* {
                                                (mall.pro || []).map((e, i) => {
                                                    return (
                                                        <dl key={i}>
                                                            <dt>{e.pro_name}</dt>
                                                            <dd>
                                                                {
                                                                    (e.spec || []).map((e2, i2) => {
                                                                        return (
                                                                            <span
                                                                                key={i2}
                                                                                style={{
                                                                                    padding: '4px 10px',
                                                                                    borderRadius: '4px',
                                                                                    border: '1px solid #f2f2f2',
                                                                                    margin: '10px 10px 10px 0',
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                            >
                                                                                {e2.spec_name}
                                                                            </span>
                                                                        )
                                                                    })
                                                                }
                                                            </dd>
                                                        </dl>

                                                    )
                                                })
                                            } */}

                  <dl hidden>
                    <dt>运费:</dt>
                    <dd>{mall.freight || "0.00"} 元</dd>
                  </dl>
                  {(this.state.spec_list || []).map((p, i) => {
                    return (
                      <dl key={i}>
                        <dt>{p.name}:</dt>
                        <dd>
                          {(p.list || []).map((sp, i2) => {
                            return (
                              <Tag
                                key={i2}
                                color={sp.isshow ? "#1890ff" : "blue"}
                                style={{
                                  borderWidth: "2px",
                                }}
                                onClick={() =>
                                  this.handlePropertyClick2(p.list, sp, i, i2)
                                }
                              >
                                {sp.name}
                              </Tag>
                            );
                          })}
                        </dd>
                      </dl>
                    );
                  })}
                  {this.state.spec_arr != "" ? (
                    <dl>
                      <dt>已选:</dt>
                      <dd>
                        {this.state.spec_arr != "" ? (
                          <div
                            style={{
                              backgroundColor: "#f2f2f2",
                              borderRadius: "4px",
                              padding: "0px 10px",
                              display: "inline-block",
                            }}
                          >
                            {(this.state.spec_arr || []).map((e, i) => {
                              return (
                                <span key={i}>
                                  {e.isshow ? " " + e.name + " " : ""}
                                </span>
                              );
                            })}
                          </div>
                        ) : null}
                        {Number(this.state.specStock) === 0 &&
                        this.state.spec_arr != "" &&
                        this.state.specStock !== "" ? (
                          <span style={{ color: "red", paddingLeft: "4px" }}>
                            该商品已售完
                          </span>
                        ) : null}
                      </dd>
                    </dl>
                  ) : null}

                  {sel_prop_code ? (
                    <dl>
                      <dt>购买对象:</dt>
                      <dd>{sel_prop_code.data_name}</dd>
                    </dl>
                  ) : null}
                  <dl>
                    <dt>数量:</dt>
                    <dd className="number-input">
                      {getFieldDecorator("number", {
                        initialValue: 1 > Number(this.state.specStock) ? 0 : 1,
                        rules: [
                          {
                            validator: this.handleEditNum,
                          },
                        ],
                      })(
                        <Input
                          size="small"
                          style={{ width: 120 }}
                          addonBefore={
                            <Icon
                              onClick={() => this.handleMinusNum()}
                              style={
                                parseInt(getFieldValue("number")) <= 1
                                  ? { color: "rgba(0,0,0,.2)" }
                                  : {}
                              }
                              type="minus"
                            />
                          }
                          addonAfter={
                            <Icon
                              onClick={() => this.handleAddNum()}
                              style={
                                parseInt(getFieldValue("number")) >=
                                parseInt(this.state.specStock || 0)
                                  ? { color: "rgba(0,0,0,.2)" }
                                  : {}
                              }
                              type="plus"
                            />
                          }
                        />
                        // <InputNumber min={1} max={parseInt(mall.stock || 0)} size="small"/>
                      )}
                      <span className="ant-form-text">
                        {" "}
                        件{" "}
                        {this.state.specStock !== ""
                          ? "（库存" + this.state.specStock + "件）"
                          : null}
                      </span>
                    </dd>
                  </dl>
                  {mall.type == 2 ? (
                    <dl>
                      <dt>店铺名称:</dt>
                      <dd>
                        {mall.merchant_name == undefined ||
                        mall.merchant_name == ""
                          ? "-"
                          : mall.merchant_name}
                      </dd>
                    </dl>
                  ) : null}
                  {mall.type == 2 ? (
                    <dl>
                      <dt>配送方式:</dt>
                      <dd>{mall.mail_way == 1 ? "包邮" : "不包邮"}</dd>
                    </dl>
                  ) : null}
                  {mall.type == 2 ? null : (
                    <dl>
                      <dt>买家留言:</dt>
                      <dd>
                        {getFieldDecorator("message")(
                          <Input.TextArea
                            rows={4}
                            placeholder="填写您的留言"
                            style={{ width: 400, marginTop: 10 }}
                          />
                        )}
                      </dd>
                    </dl>
                  )}
                  <dl style={{ paddingTop: 20 }}>
                    <dt>详情:</dt>
                    <dd>{mall.remark || "无"}</dd>
                  </dl>
                  <div style={{ color: "red" }}>{mall.statement}</div>
                  {mall.id === "4" ? (
                    <dl
                      style={{
                        width: 600,
                        height: 200,
                        border: "1px solid orange",
                        fontSize: "20px",
                        fontWeight: "bold",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        padding: "20px",
                        margin: "10px 0",
                      }}
                    >
                      <p>姓名：{user.vname}</p>
                      <p style={{ display: "flex", alignItems: "center" }}>
                        拼音：<p style={{ marginRight: 10 }}>{user.pinyin_jc}</p>
                        <Popover
                          placement="rightTop"
                          title="拼音纠错"
                          visible={pycorr_visible}
                          content={pyCorrection2}
                        >
                          <Button
                            size="small"
                            className="update-btn"
                            type="primary"
                            onClick={() => {
                              let pv = !pycorr_visible;
                              let obj = { pycorr_visible: pv };
                              if (!pv) {
                                obj.pycorr = user.pinyin_jc;
                              }
                              this.setData(obj);
                            }}
                          >
                            拼音纠错
                          </Button>
                        </Popover>
                      </p>
                      <p>编号：{user.bsrno}</p>
                    </dl>
                  ) : null}
                  {mall.id === "687" ? (
                    <dl
                      style={{
                        width: 600,
                        height: 200,
                        border: "1px solid orange",
                        fontSize: "20px",
                        fontWeight: "bold",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        padding: "20px",
                        margin: "10px 0",
                      }}
                    >
                      <p>姓名：{user.vname}</p>
                      <p style={{ display: "flex", alignItems: "center" }}>
                        血型：
                        <p style={{ marginRight: 10 }}>{user.bloodtype}</p>
                        <Popover
                          placement="rightTop"
                          title="血型纠错"
                          visible={pycorr_visible}
                          content={pyCorrection3}
                        >
                          <Button
                            size="small"
                            className="update-btn"
                            type="primary"
                            onClick={() => {
                              let pv = !pycorr_visible;
                              let obj = { pycorr_visible: pv };
                              if (!pv) {
                                obj.pycorr = user.bloodtype;
                              }
                              this.setData(obj);
                            }}
                          >
                            血型纠错
                          </Button>
                        </Popover>
                      </p>
                    </dl>
                  ) : null}
                  {mall.manufacturer_img ? (
                    <dl style={{ paddingTop: 20 }}>
                      {(mall.manufacturer_img || []).map((e, i) => {
                        return (
                          <div key={i} style={{ width: "750px" }}>
                            <img
                              style={{
                                width: "100%",
                                height: "auto",
                                borderRadius: "4px",
                              }}
                              src={
                                mall.type == 1
                                  ? config.imgUrl + e
                                  : mall.merchant_id == 2
                                  ? config.imgUrlType2 + e
                                  : config.imgUrlType3 + e
                              }
                              alt=""
                            />
                          </div>
                        );
                      })}
                    </dl>
                  ) : null}

                  {/* <dl style={{ paddingTop: 20 }}>
                                                <dt>商品描述:</dt>
                                                <dd>
                                                    
                                                </dd>
                                            </dl> */}
                </Col>
              </Row>
            )}
            <div className="receipt-info" id="receipt-info">
              {getFieldDecorator("money", { initialValue: mall.ppeprice || 0 })(
                <Input type="hidden" />
              )}

              {mall.type == 2 ? null : (
                <div>
                  <div
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#f2f2f2",
                      display: "inline-block",
                      marginBottom: "10px",
                      borderRadius: "10px",
                    }}
                  >
                    {mall.address_remark || ""}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        height: "32px",
                        textAlign: "center",
                        lineHeight: "32px",
                        margin: "0 15px",
                      }}
                    >
                      <div
                        style={{
                          padding: "0 11px",
                          border: "1px solid #d9d9d9",
                          backgroundColor: "#fafafa",
                          borderRadius: "4px",
                          borderTopRightRadius: "0",
                          borderBottomRightRadius: "0",
                        }}
                      >
                        收货人
                      </div>
                      <div
                        style={{
                          padding: "0 11px",
                          border: "1px solid #d9d9d9",
                          borderLeftWidth: "0",
                          borderRadius: "4px",
                          borderTopLeftRadius: "0",
                          borderBottomLeftRadius: "0",
                          minWidth: "200px",
                          textAlign: "left",
                        }}
                      >
                        {receivingInfor.vname || ""}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        height: "32px",
                        textAlign: "center",
                        lineHeight: "32px",
                        margin: "0 15px",
                      }}
                    >
                      <div
                        style={{
                          padding: "0 11px",
                          border: "1px solid #d9d9d9",
                          backgroundColor: "#fafafa",
                          borderRadius: "4px",
                          borderTopRightRadius: "0",
                          borderBottomRightRadius: "0",
                        }}
                      >
                        手机号码
                      </div>
                      <div
                        style={{
                          padding: "0 11px",
                          border: "1px solid #d9d9d9",
                          borderLeftWidth: "0",
                          borderRadius: "4px",
                          borderTopLeftRadius: "0",
                          borderBottomLeftRadius: "0",
                          minWidth: "200px",
                          textAlign: "left",
                        }}
                      >
                        {receivingInfor.mobile || ""}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        height: "32px",
                        textAlign: "center",
                        lineHeight: "32px",
                        margin: "0 15px",
                      }}
                    >
                      <div
                        style={{
                          padding: "0 11px",
                          border: "1px solid #d9d9d9",
                          backgroundColor: "#fafafa",
                          borderRadius: "4px",
                          borderTopRightRadius: "0",
                          borderBottomRightRadius: "0",
                        }}
                      >
                        收货地址
                      </div>
                      <div
                        style={{
                          padding: "0 11px",
                          borderLeftWidth: "0",
                          textAlign: "left",
                          fontSize: "14px",
                          minWidth: "320px",
                          border: "1px solid #d9d9d9",
                          borderRadius: "4px",
                          borderTopLeftRadius: "0",
                          borderBottomLeftRadius: "0",
                        }}
                      >
                        {receivingInfor.malladdr || ""}
                      </div>
                      <div
                        onClick={() =>
                          mall.is_team == 1
                            ? this.openEAddress(1)
                            : JSON.stringify(receivingInfor) === "{}"
                            ? this.openEAddress(2)
                            : this.openEAddress(3)
                        }
                        style={{
                          padding: "0 11px",
                          textAlign: "left",
                          color: "#1890ff",
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                      >
                        {/* is_team == 1 表示发往对部，否则发往普通用户 为1代表没有新增地址的功能 */}
                        {mall.is_team == 1
                          ? "切换地址"
                          : JSON.stringify(receivingInfor) === "{}"
                          ? "新增地址"
                          : "切换地址"}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* <Row type="flex" justify="center">
                                <FormItem>
                                    {getFieldDecorator('name', {
                                        rules: [{
                                            required: true, message: '请填写收货人',
                                        }], initialValue: receivingInfor.vname || ''
                                    })(
                                        <Input addonBefore="收货人" />
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('mobile', {
                                        rules: [{
                                            required: true, message: '请填写手机号码',
                                        }], initialValue: receivingInfor.mobile || ''
                                    })(
                                        <Input addonBefore="手机号码" />
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('address', {
                                        rules: [{
                                            required: true, message: '请填写收货地址',
                                        }], initialValue: receivingInfor.malladdr || ''
                                    })(
                                        <Input addonBefore="收货地址" addonAfter={<MoreAddress />} />
                                    )}
                                </FormItem>
                            </Row> */}
              <br />
              <div
                style={{
                  paddingRight: "15px",
                  paddingBottom: "30px",
                }}
              >
                <Button
                  type="primary"
                  loading={pay_loading}
                  className="pay-btn"
                  size="default"
                  onClick={mall.type == 1 ? this.handlePay2 : this.handleCode}
                  icon="alipay-circle"
                >
                  {mall.button_content}
                  {this.state.specSprice == 0
                    ? ""
                    : (parseFloat(this.state.specSprice) * number).toFixed(2) +
                      "元"}
                </Button>
                {mall.type == 1 ? (
                  // <Link to="/cart_index">

                  // </Link>
                  <Button
                    type="primary"
                    loading={join_loading}
                    className="car-btn"
                    size="default"
                    onClick={() => this.joinCart()}
                    icon="shopping-cart"
                    ghost
                  >
                    加入购物车
                  </Button>
                ) : null}
                {mall.id === "3" ? (
                  <Button
                    type="primary"
                    className="car-btn"
                    size="default"
                    onClick={() => this.handleLoss()}
                    icon="exception"
                  >
                    重做挂失
                  </Button>
                ) : null}
              </div>
            </div>
            <div className="qrcode" hidden={true}>
              <QRCode
                text={["微信扫一扫", "前往小程序购买"]}
                src="https://qr.api.cli.im/qr?data=http%253A%252F%252Ftest.blueskyrescue.cn%252Flogin&level=H&transparent=false&bgcolor=%23ffffff&forecolor=%23000000&blockpixel=12&marginblock=1&logourl=&size=280&kid=cliim&key=b0dc2e6f1f66803a02666daa5aaff925"
                size={120}
              />
            </div>
          </div>
        </Form>
        {/* 扫码 */}
        <Modal
          title={false}
          visible={showCodeBox}
          footer={false}
          width="296px"
          closable={false}
          onOk={() => message.info("This is a normal message")}
          onCancel={() => this.handleCode2()}
        >
          <img
            style={{
              width: "250px",
            }}
            src={
              showCodeBox
                ? config.imgUrl + this.state.good_info.mall.product_qrcode
                : ""
            }
            alt=""
          />
          <div
            style={{
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            <div
              style={{
                marginTop: "10px",
              }}
            >
              微信扫一扫
            </div>
            <div
              style={{
                marginTop: "5px",
              }}
            >
              {mall.qrcode_content}
            </div>
          </div>
        </Modal>
        {/* 编辑（新增地址） */}
        <Modal
          title={
            this.state.receiver_data.receiver_id != "" &&
            this.state.receiver_data.receiver_id != undefined
              ? "编辑收货信息"
              : "新增收货信息"
          }
          visible={eAdressStatus}
          width="420px"
          closable={true}
          onCancel={() => this.handleCodeEAdress()}
          footer={
            <Button
              type="primary"
              style={{ width: "100%" }}
              onClick={() => save()}
            >
              保存
            </Button>
          }
        >
          <div
            style={{
              position: "relative",
              zIndex: "89",
            }}
          >
            {/* {JSON.stringify(this.state.receiver_data)} */}
            <div className="item">
              <div className="title" style={{ padding: "10px 0" }}>
                收货人
              </div>
              <div className="content">
                <Input
                  ref={clear_receiver_data_name}
                  value={params.name}
                  onChange={(e) => getName(e)}
                  defaultValue={receiver_data.name}
                />
              </div>
            </div>
            <div className="item">
              <div className="title" style={{ padding: "10px 0" }}>
                手机号码
              </div>
              <div className="content">
                <Input
                  ref={clear_receiver_data_mobile}
                  value={params.num}
                  onChange={(e) => getNum(e)}
                  defaultValue={receiver_data.mobile}
                />
              </div>
            </div>
            <div className="item">
              <div className="title" style={{ padding: "10px 0" }}>
                地区
              </div>
              <div className="item2333">
                <div className="content xoxoicon">
                  <Select
                    style={{ minWidth: "160px" }}
                    value={
                      this.state.current_province != ""
                        ? this.state.current_province
                        : "选择省份"
                    }
                    // defaultValue={receiver_data.province != '' ? receiver_data.province : (this.state.current_province != '' ? this.state.current_province : '选择省份')}
                    ref={clear_current_province}
                    onChange={(e) => this.setCurrentRegion(1, e)}
                  >
                    {(this.state.regions_province || []).map((e, i) => {
                      return (
                        <Option value={e} key={i}>
                          {e}
                        </Option>
                      );
                    })}
                  </Select>
                  <Select
                    // defaultValue={this.state.current_city || '选择城市'}
                    style={{ minWidth: "100px" }}
                    value={
                      this.state.current_city != ""
                        ? this.state.current_city
                        : "选择城市"
                    }
                    onChange={(e) => this.setCurrentRegion(2, e)}
                    ref={clear_current_city}
                  >
                    {(this.state.regions_city || []).map((e, i) => {
                      return (
                        <Option value={e} key={i}>
                          {e}
                        </Option>
                      );
                    })}
                  </Select>

                  <Select
                    // defaultValue={this.state.current_area || '选择区域'}
                    style={{ minWidth: "100px" }}
                    // defaultValue={receiver_data.region != '' ? this.state.current_area : '选择区域'}
                    value={
                      this.state.current_area != ""
                        ? this.state.current_area
                        : "选择区域"
                    }
                    ref={clear_current_area}
                    onChange={(e) => this.setCurrentRegion(3, e)}
                  >
                    {(this.state.regions_area || []).map((e, i) => {
                      return (
                        <Option value={e} key={i}>
                          {e}
                        </Option>
                      );
                    })}
                  </Select>
                  {/* <div className='iconfont icon-drop_down' style={{ transform: 'scale(0.3)', position: 'relative', top: '1px' }}></div> */}
                </div>
              </div>
            </div>

            <div className="item">
              <div className="title" style={{ padding: "10px 0" }}>
                详细地址
              </div>
              <div className="content">
                <Input
                  value={params.address}
                  defaultValue={receiver_data.address}
                  ref={clear_receiver_data_address}
                  onChange={(e) => getMoreAddress(e)}
                />
              </div>
            </div>

            <div className="item" style={{ marginTop: "8px" }}>
              <div className="content">
                <div
                  onClick={() => changeCheckbox()}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    style={{
                      width: "16px",
                      height: "16px",
                      border: "1px solid #1890ff",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "2px",
                      display: "inline-block",
                      backgroundColor:
                        receiver_data.receiver_default == 1 ? "#1890ff" : "",
                      marginRight: "10px",
                    }}
                  >
                    <span
                      style={{
                        display:
                          receiver_data.receiver_default == 1
                            ? "inline-block"
                            : "none",
                        background: "#fff",
                        width: "2px",
                        height: "10px",
                        transform: "rotate(30deg)",
                        position: "relative",
                        left: "8px",
                        top: "-4px",
                      }}
                    ></span>
                    <span
                      style={{
                        display:
                          receiver_data.receiver_default == 1
                            ? "inline-block"
                            : "none",
                        background: "#fff",
                        width: "2px",
                        height: "6px",
                        transform: "rotate(317deg)",
                        position: "relative",
                        left: "2px",
                        top: "-4px",
                      }}
                    ></span>
                  </div>
                  {receiver_data.receiver_default == 1
                    ? "已设为默认"
                    : "设为默认"}
                </div>
                {/* <Checkbox
                                    ref={clear_receiver_data_isTrue}
                                    defaultChecked={params.isTrue == 1 || params.isTrue == true}
                                    value={params.isTrue == 1 || params.isTrue == true}
                                    onChange={(e) => changeCheckbox(e)}>
                                    {receiver_data.receiver_default == 1 || receiver_data.receiver_default == true ? '已设为默认' : '设为默认'}
                                </Checkbox > */}
              </div>
            </div>
          </div>
        </Modal>
        {/* 查看收货地址 */}
        <Modal
          title={<AddNewAddress />}
          visible={showAddressBox}
          footer={false}
          // footer={<AddNewAddress />}
          width="768px"
          onCancel={() => this.closeTheAdress()}
        >
          <div
            style={{
              color: "red",
              display: mall.address_remark == "" ? "none" : "block",
            }}
          >
            {mall.address_remark || ""}
          </div>
          <List
            itemLayout="horizontal"
            dataSource={address_list}
            renderItem={(item) => (
              <List.Item
                // 工作证和胸标没有编辑和删除
                actions={[
                  <div
                    onClick={() => this.openEAddress(2, item)}
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    {mall.is_team == 1 ? "" : "编辑"}{" "}
                  </div>,
                  <div
                    onClick={() => this.delCurrentAddress(item)}
                    style={{ cursor: "pointer", color: "#e4393c" }}
                  >
                    {mall.is_team == 1 ? "" : "删除"}
                  </div>,
                ]}
                style={{ cursor: "pointer" }}
              >
                <List.Item.Meta
                  avatar={false}
                  title={
                    <div>
                      <div
                        style={{
                          color: "red",
                          fontWeight: 600,
                          position: "relative",
                          left: "-8px",
                        }}
                      >
                        {item.title != "" ? item.title + "：" : ""}
                      </div>
                      <div>
                        收货人：{item.name}
                        <br />
                        手机号码：{item.mobile}
                      </div>
                    </div>
                  }
                  onClick={() => this.selectAddress(item)}
                  description={
                    <span>
                      {" "}
                      收货地址：
                      {item.province + item.city + item.region + item.address}
                    </span>
                  }
                />
              </List.Item>
            )}
          />
        </Modal>
        <div className="fix-cart-box" onClick={() => this.goToCart()}>
          <div className="iconItem2">
            <Icon type="shopping-cart" />
          </div>
          <div className="cartItme">购物车</div>
        </div>
      </div>
    );
  }
}

export default Form.create()(MWorkCard);



// WEBPACK FOOTER //
// ./src/routes/mall/MWorkCard.jsx